import {Component, OnInit} from '@angular/core';
import {NgForm} from '@angular/forms';
import {AngularFireDatabase, FirebaseObjectObservable} from 'angularfire2/database';
import {ToastrService} from 'toastr-ng2';
@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.scss']
})
export class SettingsComponent {
    settings: any = {};
    settingData: FirebaseObjectObservable<any>;

    constructor(public af: AngularFireDatabase, public toastr: ToastrService) {
        this.settingData = af.object('/settings');
        this.settingData.subscribe((res) => {
            this.settings = res;
        });
    }

    onSubmitSetting(form: NgForm) {
        this.settingData.set({totalVat: this.settings.totalVat}).then((res) => {
            this.toastr.success('Settings updated Successfully!', 'Success!');
        });
    }
}


// WEBPACK FOOTER //
// /Users/sooweeseng/Documents/Ionic Apps/FoonYew2_Backend_ok_version/webapp/src/app/routes/restaurant/settings/settings.component.ts